import { render, staticRenderFns } from "./ClientSingle.vue?vue&type=template&id=80a93b44&"
import script from "./ClientSingle.vue?vue&type=script&lang=js&"
export * from "./ClientSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/michaelzickert/Development/capture-studio/capture-studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80a93b44')) {
      api.createRecord('80a93b44', component.options)
    } else {
      api.reload('80a93b44', component.options)
    }
    module.hot.accept("./ClientSingle.vue?vue&type=template&id=80a93b44&", function () {
      api.rerender('80a93b44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ClientSingle.vue"
export default component.exports